import {format} from '../utils/string-utils';

// @formatter:off
/**
 * @ngdoc filter
 * @name strParams
 * @module portaro.filters
 * @kind function
 *
 * @param {string} string Input string
 * @param {...string} params Regexp expressions in string
 *
 * @return {string} Formatted number
 *
 * @description
 * This filter provides a means to produce concatenated messages in a language-neutral way. Use this to construct messages displayed for end users.
 * It takes a set of objects, formats them, then inserts the formatted strings into the pattern at the appropriate places.
 * See <a href="https://docs.oracle.com/javase/7/docs/api/java/text/MessageFormat.html#format(java.lang.String,%20java.lang.Object...)" target="_blank">Java MessageFormat#format</a>
 *
 * @example
 * <example module="strParamsFilterExample" name="strParamsFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-init="input = 'Hello {0}!'; param = 'world'">
            <div>
                <label for="input">Input string: </label>
                <input id="input" type="text" ng-model="input">
            </div>
            <div>
                <label for="param">Param: </label>
                <input id="param" type="text" ng-model="param">
            </div>
            <div>
                Output: {{input | strParams : param}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('strParamsFilterExample', ['portaro.filters']);
    </file>
 * </example>
 */
// @formatter:on
export default function strParamsFilter() : (_: string, ...params: string[]) => string {
    return (value: string, ...params: string[]) => {
        if (value) {
            return format(...params)(value);
        }
        return value;
    };
}

strParamsFilter.filterName = 'strParams';